import { useTranslation } from "react-i18next";
import { categories } from "@/constants/site";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <div className="text-center">
        <h2 className="text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {t("categories.title")}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
          {t("categories.browseCta")}
        </p>
      </div>

      <div className="mt-9 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
        {categories.map((c) => (
          <a
            key={c.key}
            href={c.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-28 w-full overflow-hidden sm:h-32">
              <img
                src={c.image}
                alt={t(`categories.${c.key}`)}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between gap-2 px-3 py-2.5">
              <span className="whitespace-nowrap text-sm font-medium text-foreground-800">
                {t(`categories.${c.key}`)}
              </span>
              <i className="ri-arrow-right-up-line flex h-4 w-4 shrink-0 items-center justify-center text-foreground-300 transition-colors group-hover:text-primary-500" />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}